import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatButtonModule } from '@angular/material/button'
import { MatChipsModule } from '@angular/material/chips'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { PipesModule } from '@mmx/pipes'
import { TranslateModule } from '@ngx-translate/core'

import { CustomFieldModule } from '../custom-field'
import { ChipsSelectorInputComponent } from './chips-selector.component'

@NgModule({
  imports: [
    CommonModule,
    CustomFieldModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatChipsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    PipesModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  declarations: [ChipsSelectorInputComponent],
  exports: [ChipsSelectorInputComponent],
})
export class ChipsSelectorModule {}
